document.addEventListener('DOMContentLoaded', () => {

  const sidebar = document.getElementById('sidebar');
  const overlay = document.getElementById('sidebar-overlay');

  const burger = document.getElementById('open-sidebar');
  const closeButton = document.getElementById('close-sidebar');

  function openSidebar() {
    sidebar.classList.remove('-translate-x-full');
    sidebar.classList.add('translate-x-0');

    overlay.classList.remove('hidden');
    overlay.classList.add('overlay-active');

    burger.classList.add('active');
  }

  function closeSidebar() {
    sidebar.classList.remove('translate-x-0');
    sidebar.classList.add('-translate-x-full');

    overlay.classList.add('hidden');
    overlay.classList.remove('overlay-active');


    burger.classList.remove('active');
  }

  burger?.addEventListener('click', () => {
    if (sidebar.classList.contains('-translate-x-full')) {
      openSidebar();
    } else {
      closeSidebar();
    }
  });

  closeButton?.addEventListener('click', closeSidebar);

  overlay?.addEventListener('click', closeSidebar);

});